import { IFrameStore } from '@rift/service/validation/database/syncrecording/IFrameStore';
import { IObjectStore } from '@shared/service/Indexeddb/IObjectStore';

export interface IDatabaseLineFramesStore extends IFrameStore {
}

export class DatabaseLineFramesStore implements IObjectStore {
    public static readonly keyPath: string = 'id';
    public static readonly recordingIdBlockIndex: string = 'RecordingIdBlockIndex';
    public static readonly recordingIdFrameNumberIndex: string = 'RecordingIdFrameNumberIndex';
    public static readonly recordingIdIndex: string = 'RecordingIdIndex';
    public static readonly storeDisplayName: string = 'Counts';
    public static readonly storeName: string = 'line';

    public get storeName(): string {
        return DatabaseLineFramesStore.storeName;
    };

    public static toInterface(): IDatabaseLineFramesStore {
        return {
            storeName: this.storeName,
            keyPath: this.keyPath,
            recordingIdFrameNumberIndex: this.recordingIdFrameNumberIndex,
            recordingIdIndex: this.recordingIdIndex,
            recordingIdBlockIndex: this.recordingIdBlockIndex,
        } as IDatabaseLineFramesStore;
    }

    public createStores(db: IDBDatabase): void {
        const store: IDBObjectStore = db.createObjectStore(DatabaseLineFramesStore.storeName, { keyPath: DatabaseLineFramesStore.keyPath, autoIncrement: true });
        store.createIndex(DatabaseLineFramesStore.recordingIdFrameNumberIndex, ['recordingId', 'frameNumber'], { unique: true });
        store.createIndex(DatabaseLineFramesStore.recordingIdBlockIndex, ['recordingId', 'block']);
        store.createIndex(DatabaseLineFramesStore.recordingIdIndex, 'recordingId');
    }
}
